import cuid from 'cuid';

export default cuid;